import { NegotiationQuoteDetailsQuery } from '@/generated/gql/graphql';

export enum QuoteLineItemGridField {
  POSITION = 'position',
  TITLE = 'title',
  DESCRIPTION = 'description',
  UNIT = 'unitId',
  ORGANIZATION = 'organizationId',
  DELIVERY_LOCATION = 'deliveryLocationId',
  QUANTITY = 'quantity',
  PRICE_PER_UNIT = 'pricePerUnit',
  CONTRACT = 'contract',
  FROM = 'shipmentTerms.earlyDeliveryAt',
  TO = 'shipmentTerms.lateDeliveryAt',
  DELETE_ACTION = 'deleteAction',
  COMMODITY = 'commodityId',
  STATUS = 'status',
}

export enum QuoteLineItemGridColumnGroup {
  QUOTE = 'quote',
  DELIVERY_DATE = 'deliveryDate',
  CLASSIFICATION = 'classification',
  ACTIONS = 'actions',
}

export type Quote = NonNullable<NegotiationQuoteDetailsQuery['tesseract']['negotiationCase']['quote']>;
export type QuoteLineItemGridRow = Quote['lineItems'][number] & { isMasked?: boolean };
